module.exports = __webpack_public_path__ + "static/media/grafico_distribuicao_04.6ea8e80.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grafico_distribuicao_04.mp4
// module id = P4VY
// module chunks = 0